import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DatasourceService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { ExcelExportComponent, WorkbookOptions } from '@progress/kendo-angular-excel-export';


@Component({
  selector: 'vehicles-inventory-report',
  template: `
    <kendo-excelexport [filterable]="true">
      <kendo-excelexport-column field="x" title="#" width="50"></kendo-excelexport-column>
      <kendo-excelexport-column field="vehicle_status_name" title="Estatus" width="100"></kendo-excelexport-column>
      <kendo-excelexport-column field="sku_exp" title="Folio de expediente" width="100" [cellOptions]="{ textAlign: 'right' }"></kendo-excelexport-column>
      <kendo-excelexport-column field="sku_inv" title="Folio de inventario" width="100" [cellOptions]="{ textAlign: 'right' }"></kendo-excelexport-column>
      <kendo-excelexport-column field="entry_date" title="Fecha de entrada" width="180"></kendo-excelexport-column>      
      <kendo-excelexport-column field="marck" title="Marca" width="100"></kendo-excelexport-column>
      <kendo-excelexport-column field="color" title="Color" width="100"></kendo-excelexport-column>
      <kendo-excelexport-column field="plaque" title="Placas" width="100"></kendo-excelexport-column>
      <kendo-excelexport-column field="serie" title="Número de serie" width="150"></kendo-excelexport-column>
      <kendo-excelexport-column field="authority_abbreviation" title="Abreviación Autoridad" width="100"></kendo-excelexport-column>
      <kendo-excelexport-column field="authority_name" title="Autoridad" width="250"></kendo-excelexport-column>      
      <kendo-excelexport-column field="deposit_name" title="Depósito" width="100"></kendo-excelexport-column>
      <kendo-excelexport-column field="vehicle_type_name" title="Tipo de Vehículo" width="200"></kendo-excelexport-column>      
      <kendo-excelexport-column field="vehicle_type_fee" title="Cuota" width="100" [cellOptions]="{ format: '$#,##0.00' }"></kendo-excelexport-column>
      <kendo-excelexport-column field="place" title="Lugar" width="250"></kendo-excelexport-column>      
      <kendo-excelexport-column field="output_date" title="Fecha de salida" width="180"></kendo-excelexport-column>      
      <kendo-excelexport-column field="person_name" title="Autoriza" width="220"></kendo-excelexport-column>
      <kendo-excelexport-column field="days" title="Días" width="120"></kendo-excelexport-column>
      <kendo-excelexport-column field="cost_crane" title="Costo de grúa" width="120" [cellOptions]="{ format: '$#,##0.00' }"></kendo-excelexport-column>      
      <kendo-excelexport-column field="cost_pension" title="Costo de pensión" width="120" [cellOptions]="{ format: '$#,##0.00' }"></kendo-excelexport-column>      
      <kendo-excelexport-column field="cost_subtotal" title="Subtotal" width="120" [cellOptions]="{ format: '$#,##0.00' }"></kendo-excelexport-column>      
      <kendo-excelexport-column field="cost_iva" title="I. V. A." width="120" [cellOptions]="{ format: '$#,##0.00' }"></kendo-excelexport-column>      
      <kendo-excelexport-column field="cost_total" title="Costo Total" width="120" [cellOptions]="{ format: '$#,##0.00' }"></kendo-excelexport-column>            
      <kendo-excelexport-column field="cost_discount" title="Descuento" width="120" [cellOptions]="{ format: '$#,##0.00' }"></kendo-excelexport-column>
      <kendo-excelexport-column field="cost_discount_perc" title="Porcentaje de descuento" width="120" [cellOptions]="{ format: '$#,##0.00' }"></kendo-excelexport-column>
      <kendo-excelexport-column field="cost_paid" title="Pagado" width="120" [cellOptions]="{ format: '$#,##0.00' }"></kendo-excelexport-column>      
      <kendo-excelexport-column field="payment_type_name" title="Tipo de pago" width="180"></kendo-excelexport-column>
      <kendo-excelexport-column field="customer_name" title="Cliente" width="300"></kendo-excelexport-column>
      <kendo-excelexport-column field="credit_days" title="Días de crédito" width="150"></kendo-excelexport-column>
      <kendo-excelexport-column field="expiration_date" title="Fecha de vencimiento" width="180"></kendo-excelexport-column>
      <kendo-excelexport-column field="invoice" title="Núm de factura" width="150"></kendo-excelexport-column>
      <kendo-excelexport-column field="observations" title="Observaciones" width="250"></kendo-excelexport-column>
    </kendo-excelexport>`,
  styles: [``],
})
export class VehiclesReportComponent implements OnInit {

  //ExcelExport
  @ViewChild(ExcelExportComponent, {static: false}) report !: ExcelExportComponent;

  public name: string = 'report';

  protected table: string = 'vehicles_inventories';  

  constructor(protected service : DatasourceService) { 

  }

  public downloadByStatus(id_vehicle_status: number = 0) {

    let state : State = {
      skip: 0, 
      take: 0, 
      sort: [{field: 'sku_exp', dir: 'desc'}], 
      filter: {
        logic: "and",
        filters: []
      }, 
      group: []
    }

    if(id_vehicle_status != 0){
      state.filter.filters.push({
          field: 'id_vehicle_status',
          operator: 'eq',
          value: id_vehicle_status
      })
    }

    this.readData(state);

  }

  public downloadByRange(range: any) {

    let state : State = {
      skip: 0, 
      take: 0, 
      sort: [{field: 'sku_exp', dir: 'desc'}], 
      filter: {
        logic: "or",
        filters: [
          {
            field: 'output_date',
            operator: 'inrange',
            value: `${range.start},${range.end}`
          },
          {
            field: 'entry_date',
            operator: 'inrange',
            value: `${range.start},${range.end}`
          }
        ]
      }, 
      group: []
    }

    this.readData(state);

  }

  protected readData(state: State) {    

    this.service.get(this.table, state)
      .subscribe(
        (res) => {
          console.log("RESPONSE: ", res);
          this.report.fileName = `${this.name}.xlsx`;
          this.report.data = res.data; 
          let options: WorkbookOptions = this.applyFormat(this.report);
          this.report.save(options);

        },
        (fail) => {        
          console.log("Error", fail);
        }
      ); 

  }

  protected applyFormat(report: ExcelExportComponent): WorkbookOptions {

    const options = report.workbookOptions();
    const rows = options.sheets[0].rows;
    const columns = rows[0].cells;
    // console.log(rows, columns);
    
    let index: number = 0;
    let total: number = 0;
    rows.forEach((row) => {
      if (row.type === "data") {
        index++;        
        row.cells.forEach((cell, i) => {
          if(typeof columns[i].value != 'undefined'){
            switch(columns[i].value){ 
              case '#': {
                cell.value = index;
              }; break;             
              case 'Estatus': {
                cell.background = '#' + report.data[index-1].vehicle_status_color;
                cell.color = '#ffffff';
              }; break;
              case 'Costo de grúa': {
                cell.format = "$#,##0.00";
              }; break;
              case 'Costo de pensión': {
                cell.format = "$#,##0.00";
              }; break;
              case 'Subtotal': {
                cell.format = "$#,##0.00";
              }; break;
              case 'I. V. A.': {
                cell.format = "$#,##0.00";
              }; break;
              case 'Costo Total': {
                cell.format = "$#,##0.00";
              }; break;
              case 'Pagado': {
                cell.format = "$#,##0.00";
                total= total + ((cell.value != null) ? parseFloat(<any>cell.value): 0);  
              }; break; 
              case 'Descuento': {
                cell.format = "$#,##0.00";
              }; break; 
              case 'Porcentaje de descuento': {
                cell.format = "##0.00%";
              }; break;
            }
          }
        });
      } 
      else if (row.type === "footer") {
        row.cells.forEach((cell, i) => {
          if(typeof columns[i].value != 'undefined'){
            switch(columns[i].value){ 
              case 'Pagado': {
                cell.value = total;
                cell.format = "$#,##0.00";
              }; break;
            }
          }
        });
      }
    });

    return options;

  }

  ngOnInit() {

  }

}
